import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "SearchView", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded components
export var RefinersCallout = createLazyComponent(lazyModule, function (m) { return m.RefinersCallout; });
export var SuggestionsContextMenu = createLazyComponent(lazyModule, function (m) { return m.SuggestionsContextMenu; });
export var PersonaPill = createLazyComponent(lazyModule, function (m) { return m.PersonaPill; });
export var SearchBoxPillWell = createLazyComponent(lazyModule, function (m) { return m.SearchBoxPillWell; });
export var SearchSpellCheckerSuggestion = createLazyComponent(lazyModule, function (m) { return m.SearchSpellCheckerSuggestion; });
export var SearchHeaderFirstRowContent = createLazyComponent(lazyModule, function (m) { return m.SearchHeaderFirstRowContent; });
export var SearchBox = createLazyComponent(lazyModule, function (m) { return m.SearchBox; });
//# sourceMappingURL=index.js.map